export const ROL = {
  PUNTODEVENTAROLE: 2,
  COMMERCIALROLE: 6,
  LUBRICATORROLE: 4,
  SERROLE: 5,
  COLJUEGOS: 9,
};
export const STATUS = {
  ACTIVO: 1,
  INACTIVO: 2,
  APROBADO: 6,
  RECHAZADO: 7,
};
export const ORIGIN = {
  USER: 1,
  LUBRICATOR: 2,
  DISTRIBUTOR: 3,
  PUNTODEVENTA: 4
};

// Obtener el año actual
const currentYear = new Date().getFullYear();

// Obtener los tres años anteriores
const year1 = currentYear - 1;
const year2 = currentYear - 2;
const year3 = currentYear - 3;

export const DATE = {
  year: [
    year3,
    year2,
    year1,
    currentYear
  ],
  month: [
    {
      num: "1",
      text: "Enero",
    },
    {
      num: "2",
      text: "Febrero",
    },
    {
      num: "3",
      text: "Marzo",
    },
    {
      num: "4",
      text: "Abril",
    },
    {
      num: "5",
      text: "Mayo",
    },
    {
      num: "6",
      text: "Junio",
    },
    {
      num: "7",
      text: "Julio",
    },
    {
      num: "8",
      text: "Agosto",
    },
    {
      num: "9",
      text: "Septiembre",
    },
    {
      num: "10",
      text: "Octubre",
    },
    {
      num: "11",
      text: "Noviembre",
    },
    {
      num: "12",
      text: "Diciembre",
    },
  ],
  day: [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
  ],
};
